export enum FieldRequiredValue {
  NotRequired = 'NotRequired',
  Required = 'Required',
  Idea = 'Required',
  ConceptReview = 'ConceptReview',
  ReviewDone = 'ReviewDone'
}
